// extracted by mini-css-extract-plugin
module.exports = {"image":"ck","image-placeholder":"cl","imagePlaceholder":"cl"};